import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Services } from "@/components/landing/Services";
import { Trust } from "@/components/landing/Trust";
import { PricingGuide } from "@/components/landing/PricingGuide";
import { TrainingInstitute } from "@/components/landing/TrainingInstitute";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

export const LandingPage = () => (
  <div className="bg-white">
    <Header />
    <Hero />
    <EditorialMarquee />
    <Services />
    <Trust />
    <PricingGuide />
    <TrainingInstitute />
    <Testimonials />
    <Contact />
    <Footer />
    <WhatsAppFloat />
  </div>
);
